import { useAuthContext } from "../hooks/useAuthContext";
import reportError from "../utils/reportError";

// firebase imports
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";

export const useLogout = () => {
  const { dispatch } = useAuthContext();

  const logout = () => {
    signOut(auth)
      .then(() => {
        dispatch({ type: "LOGOUT" });
      })
      .catch((err) => {
        reportError(err, "logout failure");
      });
  };

  return { logout };
};
